import { useSelector } from "react-redux";
import { RootState } from "store";

export const useGetAgencyTimezone = () => {
    const { selectedAgency } = useSelector((state: RootState) => state.auth);
    return selectedAgency?.timezone;
};

export const useGetAgencyGSTRequired = () => {
    const { selectedAgency } = useSelector((state: RootState) => state.auth);
    return selectedAgency?.gst_required;
};